(function ($, Drupal, drupalSettings, once) {

  'use strict';

  const container = document.querySelector('.js-career-block-text-right');

  // Exit on pages where the container does not exist.
  if (!container) return;

  const quoteblock = container.querySelector('.js-text-right blockquote');

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Behaviors and event management
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Drupal.behaviors.promutuel_careerBlockTextRight = {
    attach: function attach(context) {

      $(once('careerBlockTextRight', container, context)).each(async function() {
        container.style.setProperty('--jts-text-height', `${quoteblock.offsetHeight}px`);

        window.addEventListener('resize', event => {
          container.style.setProperty('--jts-text-height', `${quoteblock.offsetHeight}px`);
        });
      });
    }
  };
})(jQuery, Drupal, drupalSettings, once);
